import React, { useState } from "react";
import w1 from '../AIML Icon/1.png';
import w2 from '../AIML Icon/2.png';
import w3 from '../AIML Icon/3.png';
import w4 from '../AIML Icon/4.png';
import w5 from '../AIML Icon/5.png';

const tabs = [
  {
    title: "UI/UX Design",
    icon: w1,
    description: "Understanding client requirements to analyze suitable employees.",
    content: (
      <>
        <h3 className="text-2xl font-semibold text-[#0A2C4C] font-recoleta mb-4">Share the requirement</h3>
        <p className="text-[19px] text-[#0A2C4C] mb-4 font-recoleta">
          Understanding client requirements is key when it comes to staffing solutions. We ask our clients their demands, requirements, and goals to carefully analyze the suitable employees to recruit for their business.
        </p>
      </>
    ),
  },
  {
    title: "Frontend Developer",
    icon: w2,
    description: "Shortlisting candidates that align with your needs.",
    content: (
      <p className="text-[19px] text-[#0A2C4C] font-recoleta">
        We evaluate all candidates and shortlist only those who align with the client’s business, technical, and cultural requirements.
      </p>
    ),
  },
  {
    title: "API Development",
    icon: w3,
    description: "Efficient development and maintenance of your APIs.",
    content: (
      <>
        <h4 className="text-xl font-semibold text-[#0A2C4C] font-recoleta mb-2">Battery replacement</h4>
        <p className="text-[19px] text-[#0A2C4C]">
          Your device may get switched off often despite charging it. Whether it is battery draining quickly or not holding charge, we offer replacement and warranty.
        </p>
        <img
          src="https://static.zohocdn.com/sites/stock-images/images/zpstock-image-1263.webp"
          alt="Battery replacement"
          className="w-full max-w-md mt-4 rounded-md"
        />
      </>
    ),
  },
  {
    title: "Support & Maintenance",
    icon: w4,
    description: "Smooth onboarding with full support.",
    content: (
      <p className="text-[19px] text-[#0A2C4C] font-recoleta">
        We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.
      </p>
    ),
  },
];

const services = [
  {
    icon: w1,
    title: "UI/UX Design",
    description:
      "The creative process of developing application programs that reside on remote servers by using client-side and server-side programming.",
  },
  {
    icon: w2,
    title: "Frontend Developer",
    description:
      "We provide extensive mobile app maintenance services that cover all aspects of app maintenance, from troubleshooting to content alteration to reengineering.",
  },
  {
    icon: w3,
    title: "API Development",
    description:
      "Having a Content Management System for your website allows you to control the content without getting into coding technicalities.",
  },
  {
    icon: w4,
    title: "Support & Maintenance",
    description:
      "Regularly updating, modifying, and enhancing software applications to improve your website's performance and design.",
  },
];


const TabSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="px-4 py-10 bg-white">
      <div className="text-center mb-12">
        <h1 className="font-recoleta text-[44px] 2xl:text-[40px] lg:text-[32px]" data-aos="fade-up">
        Custom web development for your business needs
        </h1>
      </div>

      {/* Tab grid */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 max-w-7xl mx-auto mb-10">
        {services.map((service, idx) => (
          <div
            key={idx}
            className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300"
          >
            <div className="flex justify-center mb-4 lg:-mt-20">
              <img
                src={service.icon}
                alt={`${service.title} Icon`}
                className="lg:w-56  lg:h-56 lg:mt-0 -mt-44 object-contain "
              />
            </div>
            <h3 className="lg:text-xl text-[44px]  -mt-44 font-semibold text-[#0A2C4C] text-center mb-3 lg:-mt-20">{service.title}</h3>
            <p className="text-gray-700 lg:text-sm text-[34px] text-center">{service.description}</p>
            {/* <div className="mt-4 text-center">
              <a
                href="#"
                className="text-[#F86F4B] font-semibold hover:underline transition"
              >
                Read More
              </a>
            </div> */}
          </div>
        ))}
        {/* {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`flex flex-col items-center text-center p-6 rounded-xl transition border-2 shadow-sm ${
              activeIndex === index
                ? "border-[#F86F4B] bg-[#fff6f3]"
                : "border-gray-200 hover:border-[#F86F4B]"
            }`}
          >
            <h4 className="text-lg font-semibold text-[#0A2C4C] mb-2">{tab.title}</h4>
            <p className="text-sm text-[#0A2C4C]">{tab.description}</p>
          </button>
        ))}
      </div> */}

        {/* Tab Content */}
        {/* <div className="bg-gray-50 max-w-4xl mx-auto p-6 rounded-xl shadow-md font-recoleta"> */}
        {/* {tabs[activeIndex].content} */}
      </div>
    </section>
  );
};

export default TabSection;
